module.exports = __webpack_public_path__ + "static/img/bg-ar.964a64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-ar.png
// module id = Cysg
// module chunks = 1